/** 页面参与度统计服务的依赖注入标识。 */
export const TrackingTimeService = Symbol('TrackingTimeService');

/** 负责在 drafting 应用生命周期内启动和释放页面参与度统计。 */
export interface TrackingTimeService {
    /** 初始化 SDK；重复调用不会创建多个 tracker。 */
    initialize(): void;

    /** 销毁当前 tracker；重复调用不会重复上报。 */
    dispose(): Promise<void>;
}
